import { clearPendingInitialMessage } from 'common/pending-initial-message';

// Name of the BroadcastChannel that `@leagueplatform/auth-standalone` posts to
// on logout. Inlined rather than imported to avoid a dependency on the auth
// module — the same approach the SDK's own live-chat sign-out listener takes.
const AUTH_LOGOUT_BROADCAST_CHANNEL = 'auth-logout';
const LOGOUT_MESSAGE_TYPE = 'logout';

/**
 * Subscribes to the app's sign-out signal and clears any stashed pending
 * initial message so it cannot auto-send for the next member on a shared SPA
 * session. Returns an unsubscribe function.
 */
export const subscribeClearPendingInitialMessageOnSignOut =
  (): (() => void) => {
    if (typeof BroadcastChannel === 'undefined') {
      return () => {};
    }

    try {
      const channel = new BroadcastChannel(AUTH_LOGOUT_BROADCAST_CHANNEL);

      const handleMessage = (event: MessageEvent) => {
        if (event.data?.type === LOGOUT_MESSAGE_TYPE) {
          clearPendingInitialMessage();
        }
      };

      channel.addEventListener('message', handleMessage);

      return () => {
        channel.removeEventListener('message', handleMessage);
        channel.close();
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        'Failed to initialize the auth-logout BroadcastChannel; a stashed initial message will not be cleared on sign-out',
        error,
      );
      return () => {};
    }
  };
